(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-accueil-symboles"] && !Shopify.designMode) return;
  try {
    
  /* « Tous les styles » n'envoie pas de filtre de coloris vide. */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.('.bv-symboles__form');
    if (!form) return;
    form.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
      if (r.value === '') r.disabled = true;
    });
    setTimeout(() => form.querySelectorAll('input[disabled]').forEach((r) => (r.disabled = false)), 0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
